// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1NVPl","label":"Labeled_label__MsKN3","divider":"Labeled_divider__10-9O"};